import * as d3 from "d3";
import { PiePieceData } from ".";

export const createArc = (
    innerRadius: number,
    outerRadius: number,
    offset: number
) =>
    d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius - offset);

export const createExplodePiece = (innerRadius: number, outerRadius: number) =>
    d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
